var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"id":"editAssignLead","title":"Edit Lead","size":"xl","hide-footer":""}},[_c('create-lead',{attrs:{"edit_lead_id":_vm.edit_lead_id}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }